import React from 'react';
import MyPic from '../assets/images/myPicture.jpg';

const About = () => {
  return (
    <div
      name="about"
      className="h-full sm:h-screen  w-full bg-[#0a192f] text-gray-300  "
    >
      <div className="flex flex-col justify-center items-center w-screen h-full">
        <div className="max-w-[1000px] px-4 ">
          <div className="text-center pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-blue-600">
              About
            </p>
          </div>
          <div className="max-w-[1000px] w-full px-4  xs:flex-col  md:flex ">
            <div className="flex flex-1 justify-center lg:justify-left">
              <div className="absolute w-[250px] h-[320px] bg-transparent border-2 border-blue-600 mt-12 rounded-lg "></div>
              <img
                className="w-[250px] h-[320px] mt-12 rounded-lg rotate-[8deg] hover:rotate-0 duration-500"
                src={MyPic}
                alt="my-pic"
              />
            </div>
            <div className=" text-2xl flex-1 pt-12  text-center">
              <p className="text-[#8892b0]">
                Hello! My name is Akın and I am a self-taught frontend
                developer. I started my coding journey at the beginning of 2021.
                The more I deep dive into coding, the more I love it. I have no
                CS degree. I graduated from Ege University in the department of
                business administration.Later I discovered coding and i have
                changed my career path to become a developer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
